import type { StatsSnapshot } from '../../stats/gameplay-snapshot';
import type { GeneratorType } from '../../types/game-types';
import { generatorReducers } from './generator-reducers';
import { getModifiedTicksToGenerate } from '../helpers/get-modified-ticks-to-generate';
import { useGameStatsStore } from '../zustand/useGameStatsStore';
import { useGeneratorsStore } from '../zustand/useGeneratorsStore';
import { useUpgradesStore } from '../zustand/useUpgradesStore';

/**
 * Runs per-generator tick logic against a **deep-cloned** generators map + Zustand `upgrades`,
 * then commits once to `useGeneratorsStore` if anything fired (keeps React reducer slice stable).
 */
export const generateGeneratorsReducer = (): void => {
  const upgrades = useUpgradesStore.getState().upgrades;
  const baseGenerators = useGeneratorsStore.getState().generators;
  const generatorsTypes = Object.keys(baseGenerators) as GeneratorType[];

  let scratch: StatsSnapshot | undefined;

  generatorsTypes.forEach((type) => {
    const generator = (scratch?.generators ?? baseGenerators)[type];

    const ticksToGenerate = getModifiedTicksToGenerate(upgrades[type], generator, type);
    if (useGameStatsStore.getState().getActiveTicksCount() % ticksToGenerate === 0 && generator.owned > 0) {
      if (!scratch) {
        scratch = {
          upgrades,
          generators: structuredClone(baseGenerators),
        };
      }
      generatorReducers[type]?.(scratch, type);
    }
  });

  if (scratch) {
    useGeneratorsStore.getState().setGenerators(scratch.generators);
  }
};
